module.exports = __webpack_public_path__ + "img/couple.dcb03af3.svg";